/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SvgInfoAdminDto } from '../../models/svg-info-admin-dto';

export interface GetAllSvgInfoAdmin$Params {
}

export function getAllSvgInfoAdmin(http: HttpClient, rootUrl: string, params?: GetAllSvgInfoAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SvgInfoAdminDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllSvgInfoAdmin.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SvgInfoAdminDto>>;
    })
  );
}

getAllSvgInfoAdmin.PATH = '/svg-info-admin';
